// import { TriplabotaxiLocation } from '@linktivity/triplabo-taxi';
import { action, observable } from 'mobx';

export interface Location {
  name?: string;
  nameJa?: string;
  address?: string;
  mapId?: string;
  administrativeArea?: string;
  locality?: string;
  pickupLatitude?: number;
  pickupLongitude?: number;
  id?: string;
  latitude: number;
  longitude: number;
  canUse?: boolean;
  facilityUuid?: string;
  facilityMasterUuid?: string;
  facilitySpotUuid?: string;
}
export interface GpsLocation {
  latitude: number;
  longitude: number;
}

export interface TripInfo {
  pickupLocation: Location | null;
  dropoffLocation: Location | null;
  gpsLocation: GpsLocation | null;
}

export class TripStore {
  @observable accessor currentTrip: TripInfo = {
    pickupLocation: null,
    dropoffLocation: null,
    gpsLocation: null
  };

  @action
  setPickupLocation(location: Location) {
    this.currentTrip.pickupLocation = location;
  }

  @action
  setDropoffLocation(location: Location) {
    this.currentTrip.dropoffLocation = location;
  }

  @action
  setGpsLocation(location: GpsLocation) {
    this.currentTrip.gpsLocation = location;
  }

  @action
  clearTrip() {
    this.currentTrip = {
      pickupLocation: null,
      dropoffLocation: null,
      gpsLocation: null
    };
  }
}

const trip = new TripStore();

export default trip;
